import React from 'react';
import PropTypes from 'prop-types';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {SubscriptionUserFields} from 'components/common';
import {makeForm, formatRole} from 'utils/common';

class SubscriptionActivationForm extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
  };

  render() {
    const {user, handleSubmit, pristine, submitting} = this.props;
    const sentToReader = user.role === 'reader';
    const sentToParent = user.role === 'parent';
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} componentClass="h3" className="text-primary-color flex-row-center text-bold">
            This subscription was created using{' '}
            <span className="text-capitalize text-red small-margin">{formatRole(user.role)}</span> email
          </Col>
          <Col xs={12} componentClass="h3" className="text-primary-color">
            Student Information
          </Col>
          <SubscriptionUserFields prefix="reader" hideEmail={sentToReader} />
          {sentToParent && (
            <React.Fragment>
              <Col xs={12} componentClass="h3" className="text-primary-color">
                Parent Information
              </Col>
              <SubscriptionUserFields prefix="parent" hideEmail={sentToParent} />
            </React.Fragment>
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default makeForm(SubscriptionActivationForm, 'SubscriptionActivationForm', null, null);
